<template>
  <div>
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <!-- Reset Password v1 -->
        <b-card class="mb-0">
          <!-- logo -->
          <b-link class="brand-logo">
            <dutton-logo />
            <h2 class="brand-text text-primary ml-1">
              Dutton
            </h2>
          </b-link>
          <b-card-title class="mb-1">
            Nueva Contraseña 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Tu nueva contraseña debe ser diferente a tu contraseña anterior
          </b-card-text>

          <!-- Loading indicator -->
          <div
            v-if="isValidating"
            class="text-center py-4"
          >
            <b-spinner
              variant="primary"
              label="Validando enlace..."
            />
            <p class="mt-2">
              Validando enlace de recuperación...
            </p>
          </div>

          <!-- Form (solo mostrar si el token es válido) -->
          <div v-else-if="isTokenValid">
            <validation-observer ref="simpleRules">
              <b-form
                method="POST"
                class="auth-reset-password-form mt-2"
                @submit.prevent="validationForm"
              >
                <!-- password -->
                <b-form-group
                  label="Nueva contraseña"
                  label-for="reset-password-new"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="Contraseña"
                    vid="Password"
                    rules="required|password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="reset-password-new"
                        v-model="password"
                        :type="password1FieldType"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        name="reset-password-new"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password1ToggleIcon"
                          @click="togglePassword1Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- confirm password -->
                <b-form-group
                  label-for="reset-password-confirm"
                  label="Confirmar contraseña"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    name="confirmar contraseña"
                    rules="required|confirmed:Password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="reset-password-confirm"
                        v-model="cPassword"
                        :type="password2FieldType"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false:null"
                        name="reset-password-confirm"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password2ToggleIcon"
                          @click="togglePassword2Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- submit button -->
                <b-button
                  block
                  type="submit"
                  variant="primary"
                >
                  Confirmar
                </b-button>
              </b-form>
            </validation-observer>
            <p class="text-center mt-2">
              <b-link :to="{name:'login'}">
                <feather-icon icon="ChevronLeftIcon" /> Volver a login
              </b-link>
            </p>
          </div>

          <!-- Mensaje si el token no es válido -->
          <div
            v-else
            class="text-center py-4"
          >
            <p class="text-danger">
              El enlace no es válido o ha expirado. Redirigiendo...
            </p>
          </div>
        </b-card>
      <!-- /Reset Password v1 -->
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import DuttonLogo from '@core/layouts/components/Logo.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'

export default {
  components: {
    DuttonLogo,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      token: '',
      email: '',
      isTokenValid: false,
      isValidating: true,
      userEmail: '',
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mounted() {
    // Leer token y email de la URL
    this.token = this.$route.query.token || ''
    this.email = this.$route.query.email || ''

    if (!this.token || !this.email) {
      this.isValidating = false
      this.isTokenValid = false
      this.makeToast('danger', 'Error', 'Token o email no válido')
      setTimeout(() => {
        this.$router.push({ name: 'forgot-password' })
      }, 2000)
      return
    }

    // Validar el token con el backend
    this.validateToken()
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },
    validateToken() {
      axios
        .post('validate-reset-token', {
          token: this.token,
          email: this.email,
        })
        .then(response => {
          if (response.data.res && response.data.data?.valid) {
            this.isTokenValid = true
          } else {
            this.isTokenValid = false
            this.makeToast('danger', 'Error', response.data.msg || 'El enlace ha expirado o no es válido')
            setTimeout(() => {
              this.$router.push({ name: 'forgot-password' })
            }, 2000)
          }
        })
        .catch(error => {
          this.isTokenValid = false
          this.makeToast('danger', 'Error', error.response?.data?.msg || error.response?.data?.message || 'Error al validar el token')
          setTimeout(() => {
            this.$router.push({ name: 'forgot-password' })
          }, 2000)
        })
        .finally(() => {
          this.isValidating = false
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.resetPassword()
        }
      })
    },
    resetPassword() {
      axios
        .post('reset-password', {
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.cPassword,
        })
        .then(response => {
          if (response.data.res) {
            this.makeToast('success', 'Éxito', response.data.msg || 'Su contraseña ha sido actualizada con éxito')
            this.reset()
            setTimeout(() => {
              this.$router.push({ name: 'login' })
            }, 2000)
          } else {
            throw response
          }
        })
        .catch(error => {
          this.makeToast('danger', 'Error', error.response?.data?.msg || error.response?.data?.message || 'Error al actualizar la contraseña')
        })
    },
    makeToast(variant, title, message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertCircleIcon',
          variant,
          text: message,
        },
      })
    },
    reset() {
      this.cPassword = ''
      this.password = ''
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
